import { render, staticRenderFns } from "./OwnedSubscriptions.vue?vue&type=template&id=3b6f36cb"
import script from "./OwnedSubscriptions.vue?vue&type=script&lang=js"
export * from "./OwnedSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./OwnedSubscriptions.vue?vue&type=style&index=0&id=3b6f36cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports